<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Add Informational Sections
    </div>
    <div class="card-header nocollapse bg-info col-md-12 msg-container p-2">
      <b>Setting Name : </b>{{settingName}}
    </div>
    <div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button type="button" class="btn btn-sm btn-primary btn-action"
              (click)="openAddSectionModal(addSectionModal)">
        <i class="fa fa-user-plus"></i> Add Section
      </button>
      <button type="button" class="btn btn-sm btn-primary btn-action" (click)="arrangeOrder()">
        <i class="fa fa-reorder"></i> Save Order
      </button>
      <button type="button" class="btn btn-sm btn-primary btn-action" (click)="unMapSection()" [disabled]="unMapSections.length<=0">
        <i class="fa fa-remove"></i> Remove
      </button>
      <button type="button" class="btn btn-sm btn-primary btn-action float-end" (click)="BackUrl()">
        <i class="fa fa-home"></i> Home
      </button>
    </div>

    <div *ngIf="successOrFailureMessage" class="card-header nocollapse bg-info col-md-12 msg-container">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span>{{ successOrFailureMessage }}</span>
    </div>

    <div>
      <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
      <isg-grid [rowData]="settingSectionMappedList"
                [columnDefs]="sectionMappedListColumnDefs"
                [defaultColDef]="defaultsectionMappedListColDef"
                [rowDragManaged]="true"
                [config]="mappedSectionGridConfig"
                (rowSelected)="onRowSelected($event)"
                (gridReady)="onGridReady($event)">
      </isg-grid>

      <!--<ag-grid-angular style="height: 400px;"
                       class="ag-theme-quartz"
                       [rowData]="settingSectionMappedList"
                       (gridReady)="onGridReady($event)"
                       [columnDefs]="sectionMappedListColumnDefs"
                       [defaultColDef]="defaultsectionMappedListColDef"
                       [rowDragManaged]="true"
                       [animateRows]="true"
                       (rowSelected)="onRowSelected($event)"
                       rowSelection="multiple">
      </ag-grid-angular>-->
    </div>
  </div>
</div>

<!-- Add Section Modal using ng-template -->
<ng-template #addSectionModal let-modal>
  <div class="modal-header align-items-center">
    <h5 class="modal-title mb-0">Map Section(s)</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(); sectionForm.reset();"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="sectionForm">
      <div class="form-group">
        <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
        <isg-grid [rowData]="settingSectionUnMappedlist"
                  [columnDefs]="sectionUnmappedListColumnDefs"
                  [defaultColDef]="defaultsectionUnmappedListColumnDefs"
                  [config]="unmappedSectionGridConfig"
                  (rowSelected)="onRowSelected($event)"
                  (gridReady)="onGridReady($event)">
        </isg-grid>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-end">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss(); sectionForm.reset();">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-secondary btn-modal"
            [disabled]="!mapSections || mapSections.length === 0"
            (click)="modal.close(); fn_mapSection()">
      <i class="fa fa-map-o"></i> Map
    </button>
  </div>
</ng-template>
